import React, { useMemo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import ActionsTableCell from 'components/common/table/ActionsTableCell';
import CheckboxTableCell from 'components/common/table/CheckboxTableCell';
import DateTableCell from 'components/common/table/DateTableCell';
import IconButton from 'components/common/buttons/IconButton';
import ListActionsMenu from 'features/common/components/list-actions-menu/ListActionsMenu';

const FinancialProductListItem = ({ financialProduct, canWrite, onEdit, onDelete, onDuplicate, onShowStateHistory }) => {
  const actions = useMemo(
    () =>
      canWrite
        ? [
            { caption: 'Delete', handler: onDelete(financialProduct.productId), icon: 'delete', color: 'error' },
            { caption: 'Duplicate', handler: onDuplicate(financialProduct.productId), icon: 'file_copy' },
            {
              caption: 'ResidualValueGrid.ViewStateHistory',
              handler: onShowStateHistory(financialProduct.productId),
              icon: 'history',
              color: 'warning'
            }
          ]
        : [
            {
              caption: 'ResidualValueGrid.ViewStateHistory',
              handler: onShowStateHistory(financialProduct.productId),
              icon: 'history',
              color: 'warning'
            }
          ],
    [canWrite, financialProduct.productId, onDelete, onDuplicate, onShowStateHistory]
  );

  return (
    <TableRow hover key={financialProduct.productId}>
      <TableCell>{financialProduct.productName}</TableCell>
      <TableCell>{financialProduct.productCode}</TableCell>
      <TableCell>{financialProduct.leasingTypeName}</TableCell>
      <DateTableCell value={moment(financialProduct.validFrom)} />
      <DateTableCell value={moment(financialProduct.validTo)} />
      <TableCell>{financialProduct.productTypeName}</TableCell>
      <TableCell>{financialProduct.description} </TableCell>
      <CheckboxTableCell disabled={true} checked={Boolean(financialProduct.isActive)} />
      <TableCell>{financialProduct.stateName}</TableCell>
      <ActionsTableCell>
        <IconButton onClick={onEdit(financialProduct.productId)} type={canWrite ? 'edit' : 'view'} />
        <ListActionsMenu actions={actions} />
      </ActionsTableCell>
    </TableRow>
  );
};

FinancialProductListItem.propTypes = {
  financialProduct: PropTypes.object,
  canWrite: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onShowStateHistory: PropTypes.func.isRequired
};

export default FinancialProductListItem;
